import { useStorefrontHome } from './use-home';

/**
 * O link "Pronta Entrega" do menu segue o toggle do banner da home.
 *
 * Lê a MESMA query da home (`staleTime` de 5 min), então fora de `/` custa uma
 * requisição por janela de cache, e na home nenhuma. Carregando ou com erro, o
 * link fica escondido: mostrar e tirar em seguida faria a barra pular.
 */
export function useReadyDeliveryEnabled(): boolean {
  const { data } = useStorefrontHome();
  return data?.ready_delivery_banner === true;
}
